export default {
  title: 'Send a mail - Confirmation',
  information: {
    title: 'Your message is sent',
    confirmationNumber: 'No. {{msgId}}',
  },
};
